<template>
	<v-container style="padding: 0;">
		<v-dialog title="核销课次" v-model="hideShow" width="800px" persistent>
			<v-card>
				<v-card-title>
					<span>核销课时</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="cancel">
						<v-icon color="red">mdi-close-circle</v-icon>
					</v-btn>
				</v-card-title>
				<div style="width: 100%; height: 2px; background-color: #eeeeee;"></div>
				<v-card-text class="mt-5">
					<template>
						<v-data-table :headers="approve.headers" :items="approve.studentList" class="elevation-1"
							disable-pagination hide-default-footer item-key="id" :loading="loadding"
							loading-text="正在加载,请稍候......" no-data-text="暂无数据 1.请添加班级学员 2.检查学员进班日期是否晚于上课日期">

							<template v-slot:item.studentName="{item}">
								<span v-if="item.classStatus=='2'" style="color: red;">{{ item.studentName }}(请假)</span>
								<span v-else>{{ item.studentName }}</span>
								<template v-if="item.studentType=='2'">
									<v-chip small color="success" outlined class="ml-2 mt-n1">约</v-chip>
								</template>
								<template v-if="item.studentType=='3'">
									<v-chip small color="error" outlined class="ml-2 mt-n1">补</v-chip>
								</template>
							</template>
							<template v-slot:item.classStatus="{item}">
								<v-select :items="approve.classStatusItems" v-model="item.classStatus" item-text="text"
									item-value="id" dense class="mt-2" @change="statusChanged(item)"></v-select>
							</template>
							<template v-slot:item.consumeType="{item}">
								{{ consumeTypeName(item.consumeType) }}
							</template>
							<template v-slot:item.reduceQty="{item}">
								<v-text-field type="number" v-model="item.reduceQty" dense solo style="height: 30px;"
									class="mt-n2"></v-text-field>
							</template>
							<template v-slot:item.reduceAmount="{item}">
								<span v-if="item.consumeType=='2'"
									class="red--text">{{item.reduceQty * item.classHourPrice}}元</span>
								<span v-if="item.consumeType=='1'" class="red--text">{{item.reduceQty }}课时</span>
							</template>
							<template v-slot:item.courseBalance="{item}">
								<span v-if="item.consumeType=='2'">{{item.courseBalance}}元</span>
								<span v-if="item.consumeType=='1'">{{item.courseBalance }}课时</span>
							</template>

						</v-data-table>
					</template>
				</v-card-text>
				<v-card-actions>
					<v-checkbox v-model="approve.comfirmed" label="确认数据无误" color="red" dense></v-checkbox>
					<v-spacer></v-spacer>

					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitApprove" :disabled="approve.submitting|| !approve.comfirmed"
						:loading="approve.submitting" color="info">提交核销</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	export default {
		name: "approve-record",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			recordId: {
				type: String,
				default: ""
			}

		},
		watch: {
			show(newVal, oldVal) {
				console.log("newVal", newVal);
				this.hideShow = newVal;
				if (this.hideShow) {
					this.approve.comfirmed = false;
					this.approve.studentList = [];
					this.getRecordStudentList(this.recordId);
				}
			}
		},
		data() {
			return {
				loadding: false,
				hideShow: this.show,
				approve: {
					submitting: false,
					comfirmed: false,
					classStatusItems: [{
							id: "1",
							text: "到课"
						},
						{
							id: "2",
							text: "请假"
						},
						{
							id: "3",
							text: "旷课"
						},
					],
					headers: [

						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '课程余额',
							value: 'courseBalance',
							sortable: false
						},
						{
							text: '扣费方式',
							value: 'consumeType',
							sortable: false
						},
						{
							text: '本次课时',
							value: 'reduceQty',
							width: '110',
							sortable: false
						},
						{
							text: '上课状态',
							value: 'classStatus',
							width: '120',
							sortable: false
						},
						{
							text: '本次扣除',
							value: 'reduceAmount',
							width: '100',
							sortable: false
						},
					],
					checkedItems: [], //选中的学生
					studentList: [], //学生列表
					originReduceQty:"1",// 默认扣减课时数
				}
			}
		},
		mounted() {
			console.log("approve-record mounted");
		},
		methods: {
			statusChanged(item){
				console.log(item);
				if (item.classStatus=="2" ||item.classStatus=="3" ){
					item.reduceQty = "0";
				}else if (item.classStatus=="1"){
					item.reduceQty = this.originReduceQty;
				}
			},
			consumeTypeColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "success";
				}

				return color;
			},
			consumeTypeName(state) {
				let color = "未知";
				if (state === "1") {
					color = "扣课时";
				} else if (state === "2") {
					color = "扣金额";
				}

				return color;
			},
			cancel() {
				this.$emit("cancel", "");
			},
			submitApprove() {
				//提交核销
				if (!this.recordId) {
					return
				}

				if (!this.approve.comfirmed) {
					this.$noty.error("请先确认数据");
					return
				}

				this.approve.submitting = true;
				let detailList = [];
				this.approve.studentList.forEach((item, index) => {
					item.reduceQty = parseInt(item.reduceQty);
					detailList.push(item);
				});

				// api
				const that = this;
				let url = `/edu/class/record/approve`;
				let postData = {
					id: this.recordId,
					detailList: detailList
				};

				console.log(postData);

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("核销成功");

							that.approve.comfirmed = false;
							that.approve.submitting = false;
							that.$emit("success", "");
							return;
						} else {
							that.approve.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.approve.submitting = false;
						that.$noty.error('网络请求失败');
					}

				});
			},
			getRecordStudentList(recordId) {
				// 获取待核销记录的学生列表

				if (!recordId) {
					return
				}
				this.loadding = true;
				const that = this;
				let url = `/edu/class/record/student/list/` + recordId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.loadding = false;
						that.approve.studentList = response.data["data"] ? response.data["data"] : [];
						
						console.log('students',that.approve.studentList);
						
						// 设置默认扣减课时数 当状态改变为到课时要恢复默认的扣减数
						if (that.approve.studentList.length > 0){
							const student0 = that.approve.studentList[0];
							
							that.originReduceQty = student0.defaultQty;
						}
						
						return
					}
					that.loadding = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			}
		}
	}
</script>

<style>
</style>
